// extracted by mini-css-extract-plugin
export default {"form-control":"MinutesForm_form-control__lQBxl"};